import { render } from "./item-detail.vue?vue&type=template&id=366596ea&scoped=true"
import script from "./item-detail.vue?vue&type=script&lang=ts"
export * from "./item-detail.vue?vue&type=script&lang=ts"

import "./item-detail.vue?vue&type=style&index=0&id=366596ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-366596ea"

export default script